import { IOfertasServiceMock } from "@/services/saldosonline/ofertas/ofertas.types";

export const mockOfertasService = (): IOfertasServiceMock => ({
  saveUpdateOferta: jest.fn(),
  cancelOferta: jest.fn(),
  ofertasCompatibles: jest.fn(),
});
